import { render } from "./mIndex2.vue?vue&type=template&id=04a6ffbb&scoped=true"
import script from "./mIndex2.vue?vue&type=script&lang=js"
export * from "./mIndex2.vue?vue&type=script&lang=js"

import "./mIndex2.vue?vue&type=style&index=0&id=04a6ffbb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a6ffbb"]])

export default __exports__